export default "__VITE_ASSET__DNj3nu5Y__"